export default "__VITE_ASSET__BPkuOAP3__"